import { t } from 'i18next'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const userDetails = getLocalUserDetails()
const subType = userDetails?.sub?.subType

const formatNumber = (num) => num?.toLocaleString()

const formatDate = (date) => (date ? date.toUpperCase() : '-')

const getPendingTotal = (pending) => {
  if (!pending) return null

  const match = pending.match(/TOTAL\s*-\s*([\d,]+\.?\d*)/i)

  return match ? Math.round(Number(match[1].replace(/,/g, ''))) : null
}

const getPendingData = (item) => {
  const total = getPendingTotal(item.pending)

  return total !== null ? `PENDING: ${total}` : 'PENDING: -'
}

const determineTextColor = (differenceFromPreviousDay) => {
  if (differenceFromPreviousDay === 0) {
    return 'neutral'
  }
  if (differenceFromPreviousDay > 0) {
    return 'green'
  }

  return 'red'
}

const determineCellClass = (currentValue, previousValue) => {
  if (currentValue > previousValue) {
    return 'green'
  }
  if (currentValue < previousValue) {
    return 'red'
  }

  return 'neutral'
}

const determineCompareToPreviousDayClass = (differenceFromPreviousDay) => {
  const numericDifference = Number(differenceFromPreviousDay)

  if (numericDifference === 0 || Number.isNaN(numericDifference)) {
    return 'neutral'
  }
  if (numericDifference > 0) {
    return 'green'
  }

  return 'red'
}

const microSignalsUtils = {
  formatNumber,
  formatDate,
  getPendingData,
  determineTextColor,
  determineCellClass,
  determineCompareToPreviousDayClass
}

export default microSignalsUtils
